import { Navigate, Route, Routes } from "react-router-dom";
import LoginPage from "../pages/LoginPage/index";
import McpLoginPage from "../pages/McpLoginPage";
import McpCallbackPage from "../pages/McpCallbackPage";

export const PublicRoutes = () => {
  return (
    <Routes>
      <Route path="login" element={<LoginPage />} />
      <Route path="mcp-login" element={<McpLoginPage />} />
      <Route path="mcp-callback" element={<McpCallbackPage />} />
      <Route path="*" element={<Navigate to="/login" replace />} />
    </Routes>
  );
};
